// extracted by mini-css-extract-plugin
export default {"root":"ScoreCardSkeleton_root__QONiI","card":"ScoreCardSkeleton_card__u7PlJ"};